// @flow

import React from 'react';

import './Disclaimer.css';

const Disclaimer = () => (
  <div className="disclaimer">
    Information on this page may not be current. Please see the{' '}
    <a href="https://mvhs.mvla.net" target="_blank" rel="noopener noreferrer">
      official school website
    </a>{' '}
    for authoritative info.
  </div>
);

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/Disclaimer.js